import { Typography } from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import TextFieldWithStyle from "../../../HOCs/InputWithStyle/InputWithStyle";

const UserLevel = ({ getUser }) => {
	const { register, handleSubmit } = useForm();

	const findUser = ({ email }) => {
		getUser(email);
	};

	return (
		<div>
			<Typography variant="h6">Buscar usuario</Typography>
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				margin="normal"
				fullWidth
				id="email"
				label="Correo Eletronico"
				name="email"
				autoFocus
				type="text"
				inputRef={register({ required: true })}
			/>
			<br />
			<ButtonWithStyle onClick={handleSubmit(findUser)}>Buscar</ButtonWithStyle>
		</div>
	);
};

export default UserLevel;
